import { Pill } from '@/components/Pill'
import { ClickableTableCell } from '@/components/Table/ClickableTable'
import { type CellProps, type TestIdProps } from '@/components/Table/TableCell'

interface PillCellProps extends CellProps, TestIdProps {}

/**
 * A table cell that shows its content in a pill.
 */
export function PillCell({ children, testId }: PillCellProps) {
  return (
    <ClickableTableCell>
      {children && <Pill testId={testId}>{children}</Pill>}
    </ClickableTableCell>
  )
}
